export default "__VITE_PUBLIC_ASSET__9027ce06__"